//aca esta el header del menu del costado
import React, { useContext } from 'react';
import { MenuItem, MenuList, Paper, Popover, } from '@material-ui/core';
// import CmtAvatar from '../../../../@coremat/CmtAvatar';
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch } from 'react-redux';
// import { AuhMethods } from '../../../../services/auth';
// import { CurrentAuthMethod } from '../../../constants/AppConstants';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
// import PersonIcon from '@material-ui/icons/Person';
// import SettingsIcon from '@material-ui/icons/Settings';
import SidebarThemeContext from '../../../../@coremat/CmtLayouts/SidebarThemeContext/SidebarThemeContext';
import { CULogOut } from '../../../../redux/actions/ClaveUnicaActions';
import { Title, Icon, bgColor } from './SidebarHeaderContextualHeader';
//import { useLocation } from 'react-router-dom';
//import { TEXT_COLOR_FT } from 'config/config';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '20px 16px 4px 0px', //top , right, bottom, left, controla padding de icono de sidebar
    borderBottom: props => `solid 1px ${props.sidebarTheme.borderColor}`,
  },
  userInfo: {
    transition: 'all 0.1s ease',
    height: 63,
    opacity: 1,
    '.Cmt-miniLayout .Cmt-sidebar-content &': {
      opacity: 0,
      visibility: 'hidden',
      height: 0,
      paddingTop: 0,
      transition: 'none',
    }
  },
  userInfo2: {
    transition: 'all 0.1s ease',
    height: 83,
    opacity: 1,
    '.Cmt-miniLayout .Cmt-sidebar-content &': {
      opacity: 0,
      visibility: 'hidden',
      height: 0,
      paddingTop: 0,
      transition: 'none',
    }
  },
  userTitle: {
    color: props => props.sidebarTheme.textDarkColor,
    marginBottom: 8,
  },
  userSubTitle: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: 0.25,
  },
  organizacion: {
    fontSize: 'smaller',
  },
  encabezado: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  icon: {
    fontSize: 'xx-large',
    margin: '0px 1rem',
  },
}));

const SidebarHeader = () => {
  const { sidebarTheme } = useContext(SidebarThemeContext);
  const classes = useStyles({ sidebarTheme });
  const dispatch = useDispatch();

  // const location = useLocation();
  // const isFTPage = location.pathname.includes('/ft-');

  const [anchorEl, setAnchorEl] = React.useState(null);
  const usr = JSON.parse(sessionStorage.getItem('user'));

  // const handlePopoverOpen = event => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const onLogoutClick = () => {
    handlePopoverClose();
    dispatch(CULogOut());
  };

  return (
    <div className={classes.root} style={{ backgroundColor: bgColor() }}>
      {/* <div className={classes.userInfo} onClick={handlePopoverOpen}> */}
      <div className={
        usr ? 
        usr.organization.name.length >= 26 ?
        classes.userInfo2
        :
        classes.userInfo
        :
        classes.userInfo
      }>
        <div
          className="pointer"
          style={{
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'flex-center',
          }}>
          {/* <CmtAvatar src={'https://via.placeholder.com/150'} alt="User Avatar" /> */}
          <div className={classes.icon}>
            <Icon />
          </div>
          <div className={classes.encabezado}>

            {/* Nombre Modulo */}
            <h1 style={{ fontSize: 16, color: 'black' }}>
              <Title />
            </h1>
            {/* <Title /> */}
            {/* <ArrowDropDownIcon /> */}

            {usr && <label className={classes.organizacion}>{usr.organization.name}</label>}
          </div>
        </div>
      </div>

      {open && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          container={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}>
          <Paper elevation={8}>
            <MenuList>
              {/* <MenuItem onClick={handlePopoverClose}>
                <PersonIcon />
                <div className="ml-2">Profile</div>
              </MenuItem> */}
              {/* <MenuItem onClick={handlePopoverClose}>
                <SettingsIcon />
                <div className="ml-2">Settings</div>
              </MenuItem> */}
              <MenuItem onClick={onLogoutClick}>
                <ExitToAppIcon />
                <div className="ml-2">Logout</div>
              </MenuItem>
            </MenuList>
          </Paper>
        </Popover>
      )}
    </div>
  );
};

export default SidebarHeader;
